export var makeInitials = function (s, max) {
    return s
        .split(' ')
        .filter(function (_, i) { return i <= max - 1; })
        .map(function (w) { return w.charAt(0); })
        .join('');
};
